import { balance } from "../../shared/balance.ts";

// "KeyE" → "E", "Digit1" → "1", etc.
function codeToLabel(code: string): string {
  if (code.startsWith("Key")) return code.slice(3); // contracts:allow-literal — "Key" prefix length
  if (code.startsWith("Digit")) return code.slice(5); // contracts:allow-literal — "Digit" prefix length
  return code;
}

// Appends a persistent top-left DOM overlay showing the main keybindings.
// Moved from bottom-left (Phase 7 Block E) to avoid overlapping the hotbar
// which is rendered by PixiJS at the bottom-center of the viewport.
// Player ID removed — display name is now shown above the player sprite.
export function attachHudHints(_playerId: string): void {
  const el = document.createElement("div");
  el.id = "hud-hints";
  el.style.cssText =
    "position:fixed;top:8px;left:8px;font-size:11px;" +
    "font-family:monospace;color:#aaa;opacity:0.75;pointer-events:none;z-index:9999;white-space:nowrap;line-height:1.6";

  const g = codeToLabel(balance.input.gatherKey);
  const b = codeToLabel(balance.input.workbenchKey);
  const m = codeToLabel(balance.input.marketKey);
  const p = codeToLabel(balance.input.partyKey);
  const galaxy = codeToLabel(balance.input.galaxyMapKey);
  const k = codeToLabel(balance.input.statsKey);

  el.textContent =
    `WASD move · ${g} gather · ${b} workbench · ${m} market · ${p} party · ${galaxy} galaxy · ${k} skills`;
  document.body.appendChild(el);
}
